import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ScrollAnimation from 'react-animate-on-scroll';

import Modal from '../../Components/Modal/index';

import { BrowserView, MobileView, isBrowser, isMobile } from "react-device-detect";
import bgNaoGreenMobile from '../../images/nao-pedimos/bg-mobile1.svg'

import './Sobre.scss';

import BgBanner from '../../images/sobre/banner-full.png'
import Map from '../../images/sobre/map.svg'

import IconNosso from '../../images/sobre/icon-nosso.svg'
import SBMini from '../../images/icon/mini-SB.svg'

import ArrowBlue from '../../images/icon/arrow-blue.svg'
import bgNaoGreen from '../../images/nao-pedimos/bg-green.svg'
import bgNaoGreen2 from '../../images/nao-pedimos/bg-green2.svg'
import bgNaoPontos from '../../images/nao-pedimos/bg-pontos.svg'
import bgNaoYellow from '../../images/nao-pedimos/bg-yellow.svg'
import bgNaoYellowM from '../../images/nao-pedimos/bg-yellowM.svg'
import bgImage from '../../images/sobre/image-analise.png'

import ModalImage from '../../images/modal/image-modal.png'

import Heart from '../../images/icon/coracao-garante.svg'
import ImageGarante from '../../images/sobre/image-garante.png'

export default function Index() {

    const [modalFtActive, setModalFtActive] = useState(false);

    return (
        <div id="sobre">
            <div id="banner">
                <img alt="" src={BgBanner} className="animated fadeInDown" />
                <div className="content">
                    <div className="row conteudos">
                        <div className="col-lg-12 col-md-12 texts animated fadeIn">
                            <span className="font-32">
                                Sobre a
                                <b> AAAPV</b>
                            </span>
                            <p className="font-21 cl-black">
                                Somos filiados à AAAPV (Agência de Autorregulamentação das Entidades de Autogestão de Planos de Proteção Contra Riscos Patrimoniais) que é a principal entidade representativa do setor associativista. Fundada em 4 de maio de 2016, não tem fins econômicos, mas sim o compromisso de fortalecer o movimento associativista e suas relações com a sociedade, além de contribuir para o desenvolvimento econômico, social e sustentável do País.


                            </p>
                        </div>

                    </div>
                    <div className="col-lg-12 col-md-12 texts animated fadeIn">
                        <div class="row">
                            <p>A AAAPV (Agência de Autorregulamentação de Entidades de Autogestão de Planos de Proteção Veicular contra Riscos Patrimoniais), como principal entidade representativa do setor associativista, tem como premissa o aperfeiçoamento dos nossos profissionais, atender a legislação vigente, garantir a satisfação de nossos associados, atendendo aos requisitos da Gestão Antissuborno, visando a melhoria continua dos processos.<br />É de responsabilidade de todos os colaboradores conhecer e assegurar a disposição em relação aos atos de Antissuborno declarados nesta política.<br />Asseguramos a responsabilidade e comprometimento em relação a seguir.</p><ul><li><img width="16" height="16" alt="" src={SBMini} /> É proibida a prática de suborno, lavagem de dinheiro e financiamento de terrorismo;</li><li><img width="16" height="16" alt="" src={SBMini} />Cumprir com as normas anticorrupção e outros requisitos aplicáveis;</li><li><img width="16" height="16" alt="" src={SBMini} /> Cumprir códigos, políticas, procedimentos e demais documentos relacionados a integridade da AAAPV;</li><li><img width="16" height="16" alt="" src={SBMini} />Investigar e tratar as denúncias garantindo a confidencialidade e não retaliação;</li><li><img width="16" height="16" alt="" src={SBMini} />A função de Compliance Officer possuí total independência e autoridade, se mantendo disponível para auxiliar na orientação de todos os colaboradores e partes interessadas da AAAPV;</li><li><img width="16" height="16" alt="" src={SBMini} />Atender aos requisitos e melhorar continuamente o Sistema de Gestão Antissuborno;</li><li><img width="16" height="16" alt="" src={SBMini} />O não cumprimento da política Antissuborno e dos requisitos do sistema de gestão acarretará em ações disciplinares conforme descrito nesta poílitica.</li></ul><p>Ações Disciplinares:</p><ul><li><img width="16" height="16" alt="" src={SBMini} />Para as filiadas da AAAPV: todas as previstas no Código Brasileiro de Autorregulamentação da Atividade de Proteção Veicular e Patrimonial;</li><li><img width="16" height="16" alt="" src={SBMini} />Para os Dirigentes eleitos da AAAPV: todas as previstas no Código Brasileiro de Autorregulamentação da Atividade de Proteção Veicular e Patrimonial;</li><li><img width="16" height="16" alt="" src={SBMini} />Para os membros dos Tribunais de Ética: todas as previstas no Código Brasileiro de Autorregulamentação da Atividade de Proteção Veicular e Patrimonial;</li><li><img width="16" height="16" alt="" src={SBMini} />Para os funcionários da AAAPV: as previstas na CLT ;</li><li><img width="16" height="16" alt="" src={SBMini} />Para as prestadoras de serviço da AAAPV: revisão, alteração ou rescisão contratual;</li><li><img width="16" height="16" alt="" src={SBMini} />Havendo danos ao patrimônio da AAAPV, de qualquer natureza, o caso será enviado para a Procuradoria-Geral para análise de possível propositura de ação judicial de regresso.</li></ul> 						</div>
                    </div>
                </div>
            </div>


            <BrowserView>
                <div id="solicite">
                    <div className="content">
                        <div className="row">
                            <div className="col-lg-4 col-md-12 left-sl">
                                <ScrollAnimation animateOnce animateIn='fadeIn'>
                                    <img alt="" className="bg-slgrenn" width="1087" height="880" alt="" src={bgNaoGreen} />
                                </ScrollAnimation>
                                <ScrollAnimation animateOnce delay={250} animateIn='fadeIn'>
                                    <img alt="" className="bg-pontos" width="370" height="370" alt="" src={bgNaoPontos} />
                                </ScrollAnimation>

                                <span className="cl-white font-64 f-weight-700">
                                    Não
                                    pedimos
                                    análise<br />
                                    de perfil.
                                </span>
                                <Link onClick={(e) => setModalFtActive(true)} className="cl-blue border-yellow bt font-18">Solicite sua cotação online <img className="icon" width="24" height="25" alt="" src={ArrowBlue} /></Link>
                            </div>

                            <div className="col-lg-8 col-md-12 left-sr left-srot">
                                <ScrollAnimation animateOnce animateIn='fadeIn'>
                                    <img alt="" className="image" src={bgImage} />
                                    <img alt="" className="bg-slyellow" width="706" height="719" alt="" src={bgNaoYellow} />
                                </ScrollAnimation>
                                <ScrollAnimation animateOnce animateIn='fadeInRight'>
                                    <img alt="" className="bg-green2" width="179" height="359" alt="" src={bgNaoGreen2} />
                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>
                </div>
            </BrowserView>

            <MobileView>
                <div id="solicite">
                    <div className="content">
                        <div className="row">

                            <div className="col-lg-8 col-md-12 left-sr left-srot">
                                <ScrollAnimation animateOnce animateIn='fadeIn'>
                                    <img alt="" className="image image-sobre" src={bgImage} />
                                    <img alt="" className="bg-slyellow" width="273" height="504" alt="" src={bgNaoYellowM} />
                                </ScrollAnimation>
                                <ScrollAnimation animateOnce animateIn='fadeInRight'>
                                    <img alt="" className="bg-green2" width="179" height="359" alt="" src={bgNaoGreen2} />
                                </ScrollAnimation>
                            </div>
                            <div className="col-lg-4 col-md-12 left-sl">
                                <img alt="" className="bg-green-mobile" width="750" height="744" alt="" src={bgNaoGreenMobile} />
                                <img alt="" className="bg-pontos" width="370" height="370" alt="" src={bgNaoPontos} />
                                <span className="cl-white font-64 f-weight-700">
                                    Não
                                    pedimos<br />
                                    análise
                                    de perfil.
                                </span>
                                <Link onClick={(e) => setModalFtActive(true)} className="cl-blue border-yellow bt font-18">Solicite sua cotação online <img className="icon" width="24" height="25" alt="" src={ArrowBlue} /></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </MobileView>


            <Modal modalActive={modalFtActive}>
                <div id="modal-ini" className="bg-blue">
                    <button onClick={(e) => setModalFtActive(false)} className="fechar"></button>
                    <img width="520" height="293" alt="" src={ModalImage} />
                    <BrowserView>
                        <div className="buttons">
                            <a href="/form-auto" onClick={(e) => setModalFtActive(false)} className="font-16 cl-white border-white bt">Super Auto</a>
                            <Link to="/form-saude" onClick={(e) => setModalFtActive(false)} className="font-16 cl-white border-white bt">Super Saúde</Link>
                            <Link to="/form-casa" onClick={(e) => setModalFtActive(false)} className="font-16 cl-white border-white bt">Super Residência</Link>
                            <Link to="/form-pet" onClick={(e) => setModalFtActive(false)} className="font-16 cl-white border-white bt">Super Pet</Link>
                            <Link to="/form-dental" onClick={(e) => setModalFtActive(false)} className="font-16 cl-white border-white bt">Super Odonto</Link>
                        </div>
                    </BrowserView>
                    <MobileView>
                        <div className="buttons">
                            <a href="/form-auto" onClick={(e) => setModalFtActive(false)} className="font-16 cl-white border-white bt">Super Auto</a>
                            <a href="/form-saude" onClick={(e) => setModalFtActive(false)} className="font-16 cl-white border-white bt">Super Saúde</a>
                            <a href="/form-casa" onClick={(e) => setModalFtActive(false)} className="font-16 cl-white border-white bt">Super Residência</a>
                            <a href="/form-pet" onClick={(e) => setModalFtActive(false)} className="font-16 cl-white border-white bt">Super Pet</a>
                            <a href="/form-dental" onClick={(e) => setModalFtActive(false)} className="font-16 cl-white border-white bt">Super Odonto</a>
                        </div>
                    </MobileView>
                </div>

                <div className='d-none' id="line-garante">
                    <div className="content">
                        <div className="row">
                            <div className="col-12">
                                <div className="box-2">
                                    <img width="55" height="47" alt="" src={Heart} />
                                    <span className="cl-blue font-28 f-weight-700">Entenda como a Super<br /> garante seus benefícios</span>
                                    <Link to="/super-garante" className="cl-blue border-blue bt">Saiba mais</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
}
